if (!customElements.get('momento-contact-form')) {
  class MomentoContactForm extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.reasonSelect = this.querySelector('[data-contact-reason]');
      this.panels = Array.from(this.querySelectorAll('[data-contact-panel]'));
      this.submitButton = this.querySelector('[data-contact-submit]');

      if (!this.reasonSelect) return;

      this.reasonSelect.addEventListener('change', () => {
        this.setReason(this.reasonSelect.value);
      }, { signal });

      const requestedReason = new URLSearchParams(window.location.search).get('reason');
      const requestedOption = requestedReason
        ? Array.from(this.reasonSelect.options).find((option) => option.value === requestedReason)
        : null;

      if (requestedOption) this.reasonSelect.value = requestedReason;
      this.setReason(this.reasonSelect.value);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    setReason(reason) {
      let activePanel = null;

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.contactPanel === reason;
        panel.hidden = !isActive;
        panel.inert = !isActive;
        panel.querySelectorAll('input, textarea, select').forEach((field) => {
          field.disabled = !isActive;
        });
        if (isActive) activePanel = panel;
      });

      if (this.submitButton) this.submitButton.hidden = !activePanel;
    }
  }

  customElements.define('momento-contact-form', MomentoContactForm);
}
